import React from 'react';
import {Button} from '../../../index';
import {useHistory} from 'react-router';
import {Trans, useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../../const/i18nNamespaces';
import {NEW_PRESCRIPTION_DRAFT_PAGE, QUESTIONNAIRE_PAGE} from '../../../../const/routes';
import useStylesCommon from '../common/AdditionalDetailsCommonStyles';

interface PatientPrescriptionFormPromptProps {
    appointmentId: string;
}

const PatientPrescriptionFormPrompt: React.FC<PatientPrescriptionFormPromptProps> = ({
    appointmentId,
}) => {
    const history = useHistory();
    const {t} = useTranslation(i18nNamespaces.APPOINTMENT_DETAILS);
    const classesCommon = useStylesCommon();

    const goToPrescriptionForm = () => {
        history.push(`${NEW_PRESCRIPTION_DRAFT_PAGE}/${appointmentId}`);
    };

    return (
        <>
            <h4 className={classesCommon.detailsHeader}>
                {t('patientPrescriptionForm.header')}
            </h4>
            <p>
                {/* {t('patientPrescriptionForm.description')} */}
                <Trans t={t} i18nKey="patientPrescriptionForm.description" />
            </p>
            <Button
                variant="contained"
                color="secondary"
                onClick={goToPrescriptionForm}
                fullWidth
            >
                {t('patientPrescriptionForm.buttonLabel')}
            </Button>
        </>
    );
};

export default PatientPrescriptionFormPrompt;

